import { uuid } from './uuid';

const splitTerm = '-';

export namespace ParticleIdUtils {
  export function getParticleIdRoot(id: string) {
    // Some ids might end with '_particle',
    // Which is not considered part of the root id
    return id.split(splitTerm)[0].replace(/_particle$/, '');
  }

  export function generateParticleId(currentId: string, uuidFn: uuid.UuidFunc = uuid.getUuid) {
    return `${getParticleIdRoot(currentId)}${splitTerm}${uuidFn()}`;
  }
}
